module.exports = __webpack_public_path__ + "static/img/logo.3a6b1eb0.png";